module.exports = __webpack_public_path__ + "media/images/img_service_6-078a1c3ea1b1c5d35df45f2ec773ce9f.png";